import { render, staticRenderFns } from "./FlatInfo.vue?vue&type=template&id=bc5f8a24&scoped=true"
import script from "./FlatInfo.vue?vue&type=script&lang=js"
export * from "./FlatInfo.vue?vue&type=script&lang=js"
import style0 from "./FlatInfo.vue?vue&type=style&index=0&id=bc5f8a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f8a24",
  null
  
)

export default component.exports